// BUILD-046 task 9.39 (found by the browser run): the confirmation of an ACCEPTED action whose task has left the list the Caller is looking at.
//
// A manager who reassigns a report's task to someone who is not her report, or an owner who returns her claimed task to the queue, has the task leave
// her list when the host reloads it; the row that carried the message is gone, and the Caller would see the row disappear and read nothing. The
// message is kept by actionOutcomeMemory.ts; this strip shows the ones whose task is not in the list that has finished loading, each with a dismiss
// control. A task that IS in the list keeps showing its message on its own row, so nothing is shown twice. It decides and applies nothing.
import { useSyncExternalStore } from 'react';
import { actionOutcomes } from './actionOutcomeStore';

export interface ActionOutcomeNoticesProps {
  /** The ids of the tasks in the list below this strip once it has loaded (presentIdsOf), or null while it is loading or failed. */
  presentIds: readonly string[] | null;
  /** The view whose actions this strip reports ('oversight' or 'my-tasks'): the `view` the action controls were drawn for. */
  scope: string;
}

export function ActionOutcomeNotices({ presentIds, scope }: ActionOutcomeNoticesProps) {
  useSyncExternalStore(actionOutcomes.subscribe, actionOutcomes.version);
  const notices = actionOutcomes.notices(presentIds, scope);
  if (notices.length === 0) return null;
  return (
    <ul className="mb-3 space-y-1" data-testid="action-outcome-notices" aria-label="Changes you made">
      {notices.map((notice) => (
        <li key={notice.taskId}>
          <p role="status" aria-live="polite" data-testid="action-outcome-notice" className="flex items-start justify-between gap-2 text-xs bg-green-50 text-green-900 border border-green-200 rounded px-2 py-1">
            <span>
              {notice.title !== '' && <strong className="font-semibold">{notice.title}: </strong>}
              {notice.text}
            </span>
            <button type="button" onClick={() => actionOutcomes.forget(notice.taskId)} aria-label={`Dismiss message${notice.title !== '' ? `: ${notice.title}` : ''}`} className="font-bold">
              &times;
            </button>
          </p>
        </li>
      ))}
    </ul>
  );
}
